{
    "Capability": "Capacità",
    "CapabilityEnabled": "Abilitato",
    "AvailableTelServers": "Quali tipi di server di telefonia sono disponibili?",
    "AvailableLicences": "Quali sono i tipi di licenza per il sito disponibili?",
    "Broadworks": "Cisco Broadworks",
    "Webex": "Chiamata Webex",
    "LegacyTelephony": "Legacy ^^ (Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Legacy ^^(ONE, Presence, Lite, 1000, 2000)^^",
    "Enterprise": "Impresa",
    "Teams": "MS Teams",
    "MaxTelsysCount": "Numero massimo di server di telefonia in questa CME",
    "NAME": "CMECapabilities",
    "CxAnalytics": "Analisi CX",
    "CxIntegration": "Integrazione CX"
}